import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'moneyFormat'
})
export class MoneyFormatPipe implements PipeTransform {

  transform(value: number | number[], currency: boolean = true): string {
    let result: string;
    const isAddCurrency: string = currency ? ' грн.' : '';

    if (Array.isArray(value)) {
      result = this.fromArray(value, isAddCurrency);
    } else {
      result = this.fromNumber(value, isAddCurrency);
    }
    return result;
  }

  private fromArray(arr: number[], currency): string {
    return arr.map(item => item.toFixed(2)).join(' - ') + currency;
  }

  private fromNumber(num: number, currency): string {
    if (num) { return num.toFixed(2) + currency; }
    else { return ''; }
  }

}
